export { DatePickerConnected as DatePicker } from './container';
